import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowSquareOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path d="M15.496.5H9.463v1.4h3.644L7.635 7.372l.99.99 5.471-5.472v3.643h1.4z" fill="currentColor" />
                <path
                    d="M.5 9c0-5.336.715-6.381 5.5-6.49v1.4c-.905.022-1.605.078-2.156.182-.725.136-1.054.332-1.237.515s-.379.512-.515 1.237C1.952 6.583 1.9 7.59 1.9 9s.052 2.417.192 3.156c.136.725.332 1.054.515 1.237s.512.379 1.237.515c.739.14 1.745.192 3.156.192s2.417-.052 3.156-.192c.725-.136 1.054-.332 1.237-.515s.379-.512.515-1.237c.098-.517.153-1.165.177-1.99h1.4C13.356 14.8 12.275 15.5 7 15.5 1.313 15.5.5 14.688.5 9"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ArrowSquareOutlinedSize16Glyph.displayName = 'ArrowSquareOutlinedSize16Glyph';
